import { ref } from "vue";

export function useVideoUploadDialog() {
  const uploadDialogVisible = ref(false);
  const uploadShowId = ref(null);

  const openUploadDialog = (preselectedShowId = null) => {
    uploadShowId.value = preselectedShowId;
    uploadDialogVisible.value = true;
  };

  return {
    uploadDialogVisible,
    uploadShowId,
    openUploadDialog,
  };
}
